import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalOverlay } from "@chakra-ui/modal";
import React from "react";
import { MdCheck, MdFileCopy, MdHighlightOff } from "react-icons/md";
import { BsInfoCircleFill } from "react-icons/bs";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader, PopoverArrow } from "@chakra-ui/react";

const InfoModal = ({ info, varient, heading }: { info?: any; varient?: string; heading?: string }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [copied, setCopied] = React.useState<boolean>(false);
  const [isCloseModal, setIsCloseModal] = React.useState<boolean>(false);
  const [popoverOpen, setPopoverOpen] = React.useState(false);

  const handleClose = () => {
    setIsCloseModal(true);
    setTimeout(() => { setIsCloseModal(false); onClose(); }, 300);
  };

  const jsonString = JSON.stringify(info, null, 2);

  const handleCopy = () => {
    navigator.clipboard.writeText(jsonString);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <>
      <Popover trigger="hover" placement="bottom" closeOnBlur  closeOnEsc isOpen={popoverOpen && !isOpen} onOpen={() => setPopoverOpen(true)} onClose={() => setPopoverOpen(false)}>
        <PopoverTrigger>
          <button
            className="blinfo-trigger"
            onClick={() => onOpen()}
            disabled={!info}
            aria-label="View request"
            onMouseEnter={() => !isOpen && setPopoverOpen(true)} onMouseLeave={() => setPopoverOpen(false)}
          >
            <BsInfoCircleFill size={varient === "small" ? 14 : 15} />
            <span>View</span>
          </button>
        </PopoverTrigger>
        <PopoverContent border="1px solid #bfdbfe" borderRadius="12px" bg="#eff6ff" maxW="170px" p="0" overflow="hidden" zIndex="20">
          <PopoverHeader bg="#dbeafe" fontSize="12px" fontWeight="700" color="#1e40af" borderBottom="1px solid #bfdbfe" px="12px" py="9px">View Request Data</PopoverHeader>
          <PopoverArrow bg="#eff6ff" />
        </PopoverContent>
      </Popover>

      <Modal isOpen={isOpen} onClose={() => {}}>
        <ModalOverlay bg="rgba(15,23,42,0.55)" backdropFilter="blur(4px)" />
        <div className={`blinfo-panel${isOpen && !isCloseModal ? " blinfo-panel--open" : " blinfo-panel--close"}`}>
          <div className="blinfo-glow" />

          <div className="blinfo-header">
            <div className="blinfo-header-brand">
              <div className="blinfo-header-logo">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="16 16 12 12 8 16"/>
                  <line x1="12" y1="12" x2="12" y2="21"/>
                  <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/>
                </svg>
              </div>
              <div>
                <h2 className="blinfo-title">Request Data</h2>
                <p className="blinfo-sub">{heading || "Blacklist trigger request"}</p>
              </div>
            </div>
            <button className="blinfo-close" onClick={handleClose} aria-label="Close">
              <MdHighlightOff size={22} />
            </button>
          </div>

          <div className="blinfo-body">
            <div className="blinfo-toolbar">
              <span className="blinfo-toolbar-label">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/>
                </svg>
                JSON Payload
              </span>
              <button className={`blinfo-copy-btn${copied ? " blinfo-copy-btn--done" : ""}`} onClick={handleCopy}>
                {copied ? <><MdCheck size={13} /> Copied!</> : <><MdFileCopy size={13} /> Copy</>}
              </button>
            </div>
            <div className="blinfo-json-wrap">
              <pre className="blinfo-json">{jsonString}</pre>
            </div>
          </div>

          <div className="blinfo-footer">
            <span className="blinfo-footer-hint">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              Read-only view
            </span>
            <button className="blinfo-close-btn" onClick={handleClose}>Close</button>
          </div>
        </div>
      </Modal>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        .blinfo-trigger { display:inline-flex; align-items:center; gap:5px; font-family:'Plus Jakarta Sans',sans-serif; font-size:12px; font-weight:700; color:#2563eb; padding:5px 10px; border-radius:8px; border:1.5px solid #bfdbfe; background:#eff6ff; cursor:pointer; transition:all .15s; white-space:nowrap; }
        .blinfo-trigger:hover:not(:disabled) { background:#dbeafe; border-color:#93c5fd; }
        .blinfo-trigger:disabled { opacity:.4; cursor:not-allowed; }

        .blinfo-panel { font-family:'Plus Jakarta Sans',sans-serif; position:fixed; top:0; right:0; bottom:0; width:100%; max-width:580px; background:#fff; z-index:1004; display:flex; flex-direction:column; box-shadow:-12px 0 60px rgba(15,23,42,.18); transition:transform .35s cubic-bezier(0.16,1,0.3,1); overflow:hidden; }
        .blinfo-panel--open  { transform:translateX(0); }
        .blinfo-panel--close { transform:translateX(100%); }

        .blinfo-glow { height:3px; flex-shrink:0; background:linear-gradient(90deg,#1e3a8a,#2563eb,#7c3aed,#2563eb,#1e3a8a); background-size:200% 100%; animation:blinfoGlow 3s linear infinite; }
        @keyframes blinfoGlow { 0%{background-position:0%} 100%{background-position:200%} }

        .blinfo-header { padding:18px 24px; background:linear-gradient(135deg,#1e3a8a 0%,#1d4ed8 60%,#2563eb 100%); display:flex; align-items:center; justify-content:space-between; flex-shrink:0; }
        .blinfo-header-brand { display:flex; align-items:center; gap:13px; }
        .blinfo-header-logo { width:42px; height:42px; border-radius:12px; background:rgba(255,255,255,.15); border:1.5px solid rgba(255,255,255,.25); display:flex; align-items:center; justify-content:center; flex-shrink:0; }
        .blinfo-title { font-size:16px; font-weight:800; color:#fff; letter-spacing:-.3px; margin-bottom:2px; line-height:1; }
        .blinfo-sub { font-size:12px; color:rgba(255,255,255,.55); font-weight:500; }
        .blinfo-close { background:none; border:none; cursor:pointer; color:rgba(255,255,255,.65); display:flex; align-items:center; transition:color .15s; }
        .blinfo-close:hover { color:#fff; }

        .blinfo-body { flex:1; display:flex; flex-direction:column; overflow:hidden; }
        .blinfo-toolbar { display:flex; align-items:center; justify-content:space-between; padding:12px 20px; border-bottom:1px solid #f1f5f9; flex-shrink:0; }
        .blinfo-toolbar-label { display:flex; align-items:center; gap:6px; font-size:12px; font-weight:700; color:#374151; }
        .blinfo-copy-btn { display:inline-flex; align-items:center; gap:5px; font-family:'Plus Jakarta Sans',sans-serif; font-size:12px; font-weight:700; padding:6px 12px; border-radius:8px; border:1.5px solid #e2e8f0; background:#fff; color:#64748b; cursor:pointer; transition:all .15s; }
        .blinfo-copy-btn:hover { background:#f1f5f9; }
        .blinfo-copy-btn--done { border-color:#bbf7d0; background:#f0fdf4; color:#16a34a; }
        .blinfo-json-wrap { flex:1; overflow:auto; padding:0 20px 20px; }
        .blinfo-json-wrap::-webkit-scrollbar { width:4px; height:4px; }
        .blinfo-json-wrap::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:4px; }
        .blinfo-json { font-family:'Fira Code','Cascadia Code','Consolas',monospace; font-size:12.5px; line-height:1.7; color:#1e293b; background:#f8fafc; border:1px solid #e2e8f0; border-radius:12px; padding:16px 18px; margin-top:14px; white-space:pre-wrap; word-break:break-all; }

        .blinfo-footer { padding:12px 24px; border-top:1px solid #f1f5f9; background:#fafbfc; display:flex; align-items:center; justify-content:space-between; flex-shrink:0; }
        .blinfo-footer-hint { display:flex; align-items:center; gap:5px; font-size:12px; color:#94a3b8; font-weight:500; }
        .blinfo-close-btn { font-family:'Plus Jakarta Sans',sans-serif; font-size:13px; font-weight:600; color:#64748b; padding:8px 18px; border-radius:9px; border:1.5px solid #e2e8f0; background:#fff; cursor:pointer; transition:all .15s; }
        .blinfo-close-btn:hover { background:#f1f5f9; }

        @media (max-width:640px) { .blinfo-panel { max-width:100%; } }
      `}</style>
    </>
  );
};

export default InfoModal;